import customTheme from "../styles";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: "5rem 0 5rem 5rem",
      width: "100%",
      margin: "0em",
      alignContent: "center",
    },
    intro: {
      marginLeft: "-1%",
      [theme.breakpoints.down("lg")]: {
        marginLeft: "-2.5%",
      },
      [theme.breakpoints.down("md")]: {
        marginLeft: "-4%",
      },
      [theme.breakpoints.down("xs")]: {
       
        
      },
    },
    divider: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      backgroundColor: customTheme.palette.primary.main,
      [theme.breakpoints.down("xs")]: {
        marginTop: theme.spacing(4),
      },
    },
    title: {
      display: "block",
      lineHeight: "1.2",
      textAlign: "center",
      paddingTop: "1em",
      color: customTheme.palette.primary.main,
      [theme.breakpoints.down("xs")]: {
        fontSize: "55px"
      },
    },
    contactRoot: {
      position: "relative",
      display: "flex",
      width: "100%",
      marginLeft: "-2rem",
      marginBottom: "3rem",
      padding: "3rem 0",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column-reverse",
      },
      [theme.breakpoints.down("sm")]: {
        paddingBottom: "-2em",
      },
    },
    details: {
      width: "50%",
      marginLeft: "50%",
      transform: "translateX(-50%)",
      boxShadow: "5px 5px 5px 5px rgba(0,0,0,0.2)",
      padding: "4rem 4rem",
      textOverflow: "ellipsis",
      borderRadius: "2em",
      backgroundColor: customTheme.palette.primary.main,
      color: "white",
      [theme.breakpoints.down("xl")]: {
        marginTop: "70px",
      },
      [theme.breakpoints.down("md")]: {
        marginTop: "-1px",
        marginBottom: "2em",
        width: "40%",
        minWidth: "40vw",
      },
      [theme.breakpoints.down("xs")]: {
        width: "80vw",
        fontSize: "0.5em",
        display: "none",
      },
    },
    navRoot: {
      [theme.breakpoints.down("sm")]: {
        marginLeft: "-3.5em",
      },
    },
    form: {
      backgroundColor: "#fff",
      width: "100%",
      borderRadius: "2em",
      paddingTop: "2rem",
    },
    formArea: {
      display: "flex",
      [theme.breakpoints.down("lg")]: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
    },
    inputBox: {
      width: "60%",
      boxShadow: "5px 5px 8px rgba(0,0,0,0.2)",
      padding: "1.5em 1.5em",
      borderRadius: "31px",
      border: "0.5px",
      borderStyle: "solid",
      borderColor: "lightgrey",
      fontWeight: "bold",
      margin: "1em 0em",
      color: customTheme.palette.primary.main,
      outline: "none",
      maxWidth: "75%",
      [theme.breakpoints.down("xl")]: {
        marginRight: "1em",
      },
      [theme.breakpoints.down("xs")]: {
        width: "80%",
      },
    },
    msgBox: {
      width: "60%",
      boxShadow: "5px 5px 8px rgba(0,0,0,0.2)",
      padding: "1.5em 1.5em",
      borderRadius: "31px",
      marginRight: "2em",
      margin: "1em",
      color: customTheme.palette.primary.main,
      fontWeight: "bold",
      border: "0.5px",
      borderStyle: "solid",
      borderColor: "lightgrey",
      outline: "none",
      fontFamily: "inherit",
      maxWidth: "75%",
      minWidth: "60%",
      [theme.breakpoints.down("xs")]: {
        width: "80%",
      },
    },
    btn: {
      width: "60%",
      minWidth: "50%",
      padding: "1.5em 1.5em",
      margin: "3em 0em",
      backgroundColor: customTheme.palette.primary.main,
      borderRadius: "25px",
      border: "2px solid",
      fontSize: "14px",
      color: "#fff",
      lineHeight: "1.2",
      textTransform: "uppercase",
      [theme.breakpoints.down("xs")]: {
        width: "80%",
      },
      "&:hover, &:focus": {
        border: "2px solid",
        borderColor: customTheme.palette.primary.main,
        color: customTheme.palette.primary.main,
        boxShadow: `0 1em 1em -0.4em ${customTheme.palette.primary.main}`,
        // transform: "translateY(-0.25em)",
        fontWeight: "bold",
      },
    },
    icons: {
      display: "none",
      [theme.breakpoints.down("xs")]: {
        marginTop: "3em",
        display: "flex",
        boxShadow: `0 1em 1em -0.4em ${customTheme.palette.primary.main}`,
        padding: "2em 0em",
        backgroundColor: customTheme.palette.primary.main,
        justifyContent: "center",
      },
    },
  })
);
